<template>
    <Modal
            v-model="_value"
            width="500"
            title="RM设置司机卡"
            @on-visible-change="visibleChange"
            ok-text="关闭"
            cancel-text="">
        <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="80">
            <FormItem>
            </FormItem>
            <FormItem prop="driverCardNum" label="密码">
                <Button type="primary" @click="changePasswordOne" style="margin-right: 5px;">密码1</Button>
                <Button type="primary" @click="changePasswordTwo" style="margin-right: 5px;">密码2</Button>
                <Button type="primary" @click="changePasswordThree" style="margin-right: 5px;">密码3</Button>
                <Button type="primary" @click="changePasswordFour" style="margin-right: 5px;">密码4</Button>
                <Input type="password" v-model="setDriverCardParams.password" placeholder="请输入密码">
                </Input>
            </FormItem>
            <FormItem prop="driverName" label="驾驶员名">
                <Input v-model="setDriverCardParams.driverName" placeholder="请输入驾驶员名">
                </Input>
            </FormItem>

<!--                  <FormItem prop="driverCardNum" label="司机卡号">-->
<!--                    <Input v-model="setDriverCardParams.driverCardNum" placeholder="请输入司机卡号">-->
<!--                    </Input>-->
<!--                  </FormItem>-->
            <FormItem prop="driverLicenseNum" label="驾驶证号">
                <Input v-model="setDriverCardParams.driverLicenseNum" placeholder="请输入驾驶证号">
                </Input>
            </FormItem>
            <FormItem prop="organizationNames" label="发证机构名称">
                <Input v-model="setDriverCardParams.organizationNames" placeholder="请输入发证机构名称">
                </Input>
            </FormItem>
            <FormItem prop="date" label="证件有效期">
                <DatePicker style="display: inline-block; width: 200px;" type="date" v-model="setDriverCardParams.date"
                            placeholder="选择日期"></DatePicker>
            </FormItem>
            <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
            <Button type="primary" @click="onSendDriverCardParams">发送</Button>
        </Form>
    </Modal>
</template>

<script>

    import Vue from 'vue'
    import {mapActions} from 'vuex'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'

    export default {
        name: 'rmsetdrivercardmodal',
        components: {},
        props: {
            initValue: null,
            terminalNumValue: null,
            value: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                setDriverCardParams: {
                    id: null,
                    password: 'admin',
                    driverName: null,
                    driverLicenseNum: null,
                    driverCardNum: null,
                    organizationNames: null,
                    indate: null,
                    date: null
                }

            }
        },
        methods: {
            ...mapActions([
                'VehicleInfoServ_SearchByName'
            ]),
            visibleChange(val) {
                if (val) {
                    this.setDriverCardParams.id = this._initValue
                    this.setDriverCardParams.driverName = null
                    this.setDriverCardParams.driverLicenseNum = null
                    this.setDriverCardParams.driverCardNum = null
                    this.setDriverCardParams.organizationNames = null
                    this.setDriverCardParams.indate = null
                    this.setDriverCardParams.date = null
                    this.changePasswordOne()
                }
            },
            changePasswordOne() {
                this.setDriverCardParams.password = 'admin'
            },
            changePasswordTwo() {
                this.setDriverCardParams.password = 'JC336699'
            },
            changePasswordThree() {
                this.setDriverCardParams.password = ''
            },
            changePasswordFour() {
                this.setDriverCardParams.password = '870315'
            },
            onCleanDriverCardParams() {
                // console.log('99admin,' + this.setDriverCardParams.password + ',SICC'
                //     + this.setDriverCardParams.driverName + ','
                //     + this.setDriverCardParams.driverLicenseNum + ','
                //     + this.setDriverCardParams.driverCardNum + ','
                //     + this.setDriverCardParams.organizationNames + ','
                //     + this.setDriverCardParams.organizationNames
                //     + '!')
                this.setDriverCardParams.driverName = null
                this.setDriverCardParams.driverLicenseNum = null
                this.setDriverCardParams.driverCardNum = null
                this.setDriverCardParams.organizationNames = null
                this.setDriverCardParams.indate = null
                this.setDriverCardParams.date = null
            },
            onSendDriverCardParams() {
                if (this.setDriverCardParams.driverName == null) {
                    this.$Message.error('请输入驾驶员名')
                    return;
                }
                if (this.setDriverCardParams.driverLicenseNum == null) {
                    this.$Message.error('请输入驾驶证号')
                    return;
                }
                if (this.setDriverCardParams.driverLicenseNum != null) {
                    this.setDriverCardParams.driverCardNum = this.setDriverCardParams.driverLicenseNum
                }
                if (this.setDriverCardParams.date == null) {
                    this.$Message.error('请输入有效期')
                    return
                } else {
                    this.setDriverCardParams.indate = this.setDriverCardParams.date.Format('yyyyMMdd').substring(2)
                }
                this.$Modal.confirm({
                    title: '指令确认',
                    content: '99admin,' + this.setDriverCardParams.password + ',SICC'
                        + this.setDriverCardParams.driverName + ','
                        + this.setDriverCardParams.driverLicenseNum + ','
                        + this.setDriverCardParams.driverCardNum + ','
                        + this.setDriverCardParams.organizationNames + ','
                        + this.setDriverCardParams.indate
                        + '!',
                    onOk: () => {

                        store.dispatch('NetCommandServ_SendCommand', {
                            params: {
                                id: this._initValue,
                                content: '99admin,' + this.setDriverCardParams.password + ',SICC' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.driverLicenseNum + ',' + this.setDriverCardParams.driverCardNum + ',' + this.setDriverCardParams.organizationNames + ',' + this.setDriverCardParams.indate + '!',
                                urgent: false
                            }
                        }).then(() => {
                            this.$Message.success('发送成功')
                        }).catch(err => {
                            this.$Message.error(err)
                        })

                    },
                    onCancel: () => {
                    }
                })
            }
        },
        computed: {
            _value: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                    this.$emit('change', val)
                }
            },
            _initValue: {
                get() {
                    return this.initValue
                },
                set(val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            },
            _terminalNumValue: {
                get() {
                    return this.terminalNumValue
                },
                set(val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            }
        },
        mounted() {
            this.$nextTick(() => {

            })
        }
    }
</script>
